// extracted by mini-css-extract-plugin
export default {"text":"n7mbsgI56aV9K8_ctcQdD"};